import React from 'react'
import PropTypes from 'prop-types'
import { withNavigation } from '../../../hoc'
import NavigationMenu from '../Sidebar/Menu'
import SIDEBAR_ROUTES from '../../../routes'

class SidebarContent extends React.Component {
    render () {
        const { pathname, collapsed, navigate, location, onClickMenuItemCallback } = this.props
        return (
            <NavigationMenu
                collapsed={collapsed}
                routes={SIDEBAR_ROUTES}
                currentPathname={pathname || location.pathname}
                navigate={navigate}
                onClickMenuItemCallback={onClickMenuItemCallback}
            />
        );
    }
}

SidebarContent.propTypes = {
    collapsed: PropTypes.bool,
    pathname: PropTypes.string,
    navigate: PropTypes.func,
    location: PropTypes.object
}

SidebarContent.defaultProps = {
    routes: [],
    resources: []
}

export default withNavigation(SidebarContent)
